import { render, staticRenderFns } from "./StatisticsIcon.vue.vue?vue&type=template&id=7104c94e&"
import script from "./StatisticsIcon.vue.vue?vue&type=script&lang=js&"
export * from "./StatisticsIcon.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports